import { TopWinnerItem } from "../../../(custom-header)/winners-template/ComponentsMapper";
import { InstantWinWinnersResponse } from "./winners.types";

const MOCK_WINNERS: TopWinnerItem[] = [
  {
    id: 1,
    userName: "Michael J.",
    make: "Range",
    model: "Rover",
    prizeThumbnailImageUrl: "/assets/images/winners/mercedes.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 2,
    userName: "Liam R.",
    make: "Audi",
    model: "RS6",
    prizeThumbnailImageUrl: "/assets/images/winners/audi-1.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 3,
    userName: "Catherine W.",
    make: "Mini",
    model: "Cooper",
    prizeThumbnailImageUrl: "/assets/images/winners/honda.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 4,
    userName: "Sophie T.",
    make: "£10,000",
    model: "Cash",
    prizeThumbnailImageUrl: "/assets/images/winners/prize.png",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 5,
    userName: "James K.",
    make: "Ford",
    model: "Mustang",
    prizeThumbnailImageUrl: "/assets/images/winners/ford.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 6,
    userName: "Emma L.",
    make: "Renault",
    model: "Megane",
    prizeThumbnailImageUrl: "/assets/images/winners/renault.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 7,
    userName: "Oliver W.",
    make: "Mercedes",
    model: "AMG",
    prizeThumbnailImageUrl: "/assets/images/winners/mercedes.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 8,
    userName: "Amelia P.",
    make: "Audi",
    model: "R8",
    prizeThumbnailImageUrl: "/assets/images/winners/audi-2.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 9,
    userName: "Noah C.",
    make: "Honda",
    model: "Civic",
    prizeThumbnailImageUrl: "/assets/images/winners/honda.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 10,
    userName: "Isla M.",
    make: "£5,000",
    model: "Cash",
    prizeThumbnailImageUrl: "/assets/images/winners/prize.png",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 11,
    userName: "George H.",
    make: "Ford",
    model: "Focus RS",
    prizeThumbnailImageUrl: "/assets/images/winners/ford.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 12,
    userName: "Mia B.",
    make: "Renault",
    model: "Clio",
    prizeThumbnailImageUrl: "/assets/images/winners/renault.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 13,
    userName: "Harry D.",
    make: "Mercedes",
    model: "C63",
    prizeThumbnailImageUrl: "/assets/images/winners/mercedes.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 14,
    userName: "Ava S.",
    make: "Audi",
    model: "TT",
    prizeThumbnailImageUrl: "/assets/images/winners/audi-1.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 15,
    userName: "Jack F.",
    make: "Honda",
    model: "Type R",
    prizeThumbnailImageUrl: "/assets/images/winners/honda.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 16,
    userName: "Grace N.",
    make: "£2,500",
    model: "Cash",
    prizeThumbnailImageUrl: "/assets/images/winners/prize.png",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 17,
    userName: "Leo R.",
    make: "Ford",
    model: "Puma",
    prizeThumbnailImageUrl: "/assets/images/winners/ford.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 18,
    userName: "Poppy A.",
    make: "Renault",
    model: "Captur",
    prizeThumbnailImageUrl: "/assets/images/winners/renault.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 19,
    userName: "Oscar G.",
    make: "Mercedes",
    model: "GLE",
    prizeThumbnailImageUrl: "/assets/images/winners/mercedes.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 20,
    userName: "Freya J.",
    make: "Audi",
    model: "Q5",
    prizeThumbnailImageUrl: "/assets/images/winners/audi-2.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 21,
    userName: "Charlie E.",
    make: "Honda",
    model: "Jazz",
    prizeThumbnailImageUrl: "/assets/images/winners/honda.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 22,
    userName: "Lily V.",
    make: "£7,500",
    model: "Cash",
    prizeThumbnailImageUrl: "/assets/images/winners/prize.png",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 23,
    userName: "Thomas B.",
    make: "Ford",
    model: "Fiesta ST",
    prizeThumbnailImageUrl: "/assets/images/winners/ford.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 24,
    userName: "Rosie K.",
    make: "Renault",
    model: "Arkana",
    prizeThumbnailImageUrl: "/assets/images/winners/renault.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 25,
    userName: "Ethan L.",
    make: "Mercedes",
    model: "A45",
    prizeThumbnailImageUrl: "/assets/images/winners/mercedes.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 26,
    userName: "Ruby W.",
    make: "Audi",
    model: "A3",
    prizeThumbnailImageUrl: "/assets/images/winners/audi-1.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 27,
    userName: "Henry Q.",
    make: "Honda",
    model: "CR-V",
    prizeThumbnailImageUrl: "/assets/images/winners/honda.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 28,
    userName: "Ella T.",
    make: "£15,000",
    model: "Cash",
    prizeThumbnailImageUrl: "/assets/images/winners/prize.png",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 29,
    userName: "William Z.",
    make: "Ford",
    model: "Ranger",
    prizeThumbnailImageUrl: "/assets/images/winners/ford.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 30,
    userName: "Daisy U.",
    make: "Renault",
    model: "Austral",
    prizeThumbnailImageUrl: "/assets/images/winners/renault.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 31,
    userName: "Alfie X.",
    make: "Mercedes",
    model: "E63",
    prizeThumbnailImageUrl: "/assets/images/winners/mercedes.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 32,
    userName: "Sienna O.",
    make: "Audi",
    model: "e-tron",
    prizeThumbnailImageUrl: "/assets/images/winners/audi-2.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 33,
    userName: "Archie I.",
    make: "Honda",
    model: "e:Ny1",
    prizeThumbnailImageUrl: "/assets/images/winners/honda.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 34,
    userName: "Willow Y.",
    make: "£20,000",
    model: "Cash",
    prizeThumbnailImageUrl: "/assets/images/winners/prize.png",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 35,
    userName: "Freddie P.",
    make: "Ford",
    model: "Kuga",
    prizeThumbnailImageUrl: "/assets/images/winners/ford.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 36,
    userName: "Florence C.",
    make: "Renault",
    model: "Scenic",
    prizeThumbnailImageUrl: "/assets/images/winners/renault.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 37,
    userName: "Teddy H.",
    make: "Mercedes",
    model: "CLA",
    prizeThumbnailImageUrl: "/assets/images/winners/mercedes.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 38,
    userName: "Ivy D.",
    make: "Audi",
    model: "S3",
    prizeThumbnailImageUrl: "/assets/images/winners/audi-1.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 39,
    userName: "Arthur N.",
    make: "Honda",
    model: "HR-V",
    prizeThumbnailImageUrl: "/assets/images/winners/honda.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 40,
    userName: "Evie M.",
    make: "£3,000",
    model: "Cash",
    prizeThumbnailImageUrl: "/assets/images/winners/prize.png",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 41,
    userName: "Theo S.",
    make: "Ford",
    model: "Explorer",
    prizeThumbnailImageUrl: "/assets/images/winners/ford.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 42,
    userName: "Millie R.",
    make: "Renault",
    model: "Zoe",
    prizeThumbnailImageUrl: "/assets/images/winners/renault.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 43,
    userName: "Finley A.",
    make: "Mercedes",
    model: "GLC",
    prizeThumbnailImageUrl: "/assets/images/winners/mercedes.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 44,
    userName: "Phoebe G.",
    make: "Audi",
    model: "Q3",
    prizeThumbnailImageUrl: "/assets/images/winners/audi-2.webp",
    prizeUrl: "/prizes/instantwin",
  },
  {
    id: 45,
    userName: "Sebastian F.",
    make: "Honda",
    model: "ZR-V",
    prizeThumbnailImageUrl: "/assets/images/winners/honda.webp",
    prizeUrl: "/prizes/instantwin",
  },
];

export function generateMockWinnersPage(page: number, pageSize: number): InstantWinWinnersResponse {
  const totalCount = MOCK_WINNERS.length;
  const totalPages = Math.ceil(totalCount / pageSize);
  const start = page * pageSize;
  const winners = MOCK_WINNERS.slice(start, start + pageSize);

  return {
    winners,
    page,
    count: winners.length,
    itemStartingIndex: start,
    totalPages,
    totalCount,
  };
}
